import {
  getInt32,
  getFloat,
} from "@surya-digital/leo-ts-types";

export interface SurveyBreakdownDTO {
  volume: number;
  percentage: number;
}

export class SurveyBreakdown {
  readonly isSurveyBreakdownSurveyBreakdown: boolean = true;

  readonly volume: number;
  readonly percentage: number;

  static readonly constraints = {
    "volume": {
      "minValue": 0,
    },
    "percentage": {
      "minValue": 0,
      "maxValue": 100,
    }
  }

  constructor(
  volume: number, 
  percentage: number
  ) {
    SurveyBreakdown.validateVolume(volume);
    this.volume = volume;
    SurveyBreakdown.validatePercentage(percentage);
    this.percentage = percentage;
  }

  static fromDTO(dto: SurveyBreakdownDTO): SurveyBreakdown {
    const volume = getInt32(dto, "volume", InvalidSurveyBreakdownVolumeError);
    const percentage = getFloat(dto, "percentage", InvalidSurveyBreakdownPercentageError);
    return new SurveyBreakdown(
      volume,
      percentage
    );
  }

  toDTO(): SurveyBreakdownDTO {
    const dto: SurveyBreakdownDTO = {
        volume: this.volume,
        percentage: this.percentage
    };
    return dto;
  }
  private static validateVolume = (volume: number): void => {
    if(volume < 0) {
      throw new InvalidSurveyBreakdownVolumeMinValueError(
        0,
        `Attribute volume has value ${volume}. Min value is 0.`
      );
    }
  }
  private static validatePercentage = (percentage: number): void => {
    if(percentage < 0) {
      throw new InvalidSurveyBreakdownPercentageMinValueError(
        0,
        `Attribute percentage has value ${percentage}. Min value is 0.`
      );
    }
    if(percentage > 100) {
      throw new InvalidSurveyBreakdownPercentageMaxValueError(
        100,
        `Attribute percentage has value ${percentage}. Max value is 100.`
      );
    }
  }
  
}

SurveyBreakdown.prototype.toString = function toString(): string {
  return `SurveyBreakdown(volume='${this.volume}',percentage='${this.percentage}')`;
};

export class InvalidSurveyBreakdownError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyBreakdownError";
  }
}
export class InvalidSurveyBreakdownVolumeError extends InvalidSurveyBreakdownError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyBreakdownVolumeError";
  }
}

export class InvalidSurveyBreakdownVolumeMinValueError extends InvalidSurveyBreakdownVolumeError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyBreakdownVolumeMinValueError";
  }
}

export class InvalidSurveyBreakdownPercentageError extends InvalidSurveyBreakdownError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyBreakdownPercentageError";
  }
}

export class InvalidSurveyBreakdownPercentageMaxValueError extends InvalidSurveyBreakdownPercentageError {
  readonly maxValue: number;
  constructor(maxValue: number, message?: string) {
    super(message);
    this.maxValue = maxValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyBreakdownPercentageMaxValueError";
  }
}

export class InvalidSurveyBreakdownPercentageMinValueError extends InvalidSurveyBreakdownPercentageError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyBreakdownPercentageMinValueError";
  }
}
